import React from 'react';
import "./style.css";
import SeoHead from '../../Components/SeoHead/SeoHead';

function Company() {
    return (
        <>
            <SeoHead
                title="Nosotros"
                path="/nosotros"
                description="Conocé la historia de Marmolería Colaiacovo: más de 60 años transformando espacios con mármoles, granitos y cuarzos de primera calidad en Buenos Aires."
            />
            <div className="container mx-auto px-4 py-12 max-w-3xl">
                <h1 className="text-3xl font-bold mb-8 text-center">Nosotros</h1>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-3">Nuestra historia</h2>
                    <p className="mb-4">
                        Marmolería Colaiacovo nació hace más de 60 años con una misión clara: brindar materiales
                        de primera calidad y un servicio de instalación profesional que transforme cada espacio.
                        Con décadas de trayectoria, nos consolidamos como referentes del sector en el barrio de
                        Flores, Capital Federal.
                    </p>
                    <p>
                        Cada proyecto es único. Por eso trabajamos con atención personalizada, asesorando a cada
                        cliente en la elección del material ideal para su hogar, oficina o emprendimiento comercial.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-3">Nuestros materiales</h2>
                    <ul className="list-disc list-inside space-y-2">
                        <li><strong>Mármoles</strong> — elegancia clásica para encimeras, pisos y revestimientos.</li>
                        <li><strong>Granitos</strong> — durabilidad y resistencia para cocinas y exteriores.</li>
                        <li><strong>Cuarzos</strong> — superficie compuesta de alta resistencia y bajo mantenimiento.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold mb-3">¿Por qué elegirnos?</h2>
                    <ul className="list-disc list-inside space-y-2">
                        <li>Más de 60 años de experiencia en el rubro</li>
                        <li>Amplia variedad de materiales nacionales e importados</li>
                        <li>Equipo de instalación profesional propio</li>
                        <li>Atención personalizada y presupuesto sin cargo</li>
                        <li>Ubicados en Flores, Buenos Aires — fácil acceso</li>
                    </ul>
                </section>
            </div>
        </>
    );
}

export default Company;
